import React from 'react';
import './style.css';

export function Skeleton({ width, height, borderRadius, style, className, count = 1 }) {
  const skeletons = Array.from({ length: count }).map((_, i) => (
    <div
      key={i}
      className={`skeleton-line ${className || ''}`}
      style={{
        width: width || '100%',
        height: height || '20px',
        borderRadius: borderRadius || '4px',
        marginBottom: count > 1 ? '8px' : 0,
        ...style
      }}
    />
  ));

  return <>{skeletons}</>;
}

export function TableSkeleton() {
  return (
    <div className="skeleton-card skeleton-table-card">
      <div className="skeleton-table-header">
        <div className="skeleton-line skeleton-header-col" />
        <div className="skeleton-line skeleton-header-col" />
        <div className="skeleton-line skeleton-header-col" />
        <div className="skeleton-line skeleton-header-col" />
        <div className="skeleton-line skeleton-header-col" />
      </div>
      <div className="skeleton-table-rows">
        {Array.from({ length: 5 }).map((_, index) => (
          <div key={index} className="skeleton-table-row">
            <div className="skeleton-table-cell-primary">
              <div className="skeleton-circle skeleton-avatar" />
              <div className="skeleton-column">
                <div className="skeleton-line skeleton-title-line" />
                <div className="skeleton-line skeleton-subtitle-line short" />
              </div>
            </div>
            <div className="skeleton-line skeleton-cell-line" />
            <div className="skeleton-line skeleton-cell-line" />
            <div className="skeleton-pill skeleton-tag" />
            <div className="skeleton-row-actions">
              <div className="skeleton-pill skeleton-action" />
              <div className="skeleton-pill skeleton-action" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function PointCardSkeleton() {
  return (
    <div className="skeleton-card point-card-skeleton">
      <div className="point-card-header-skeleton">
        <div className="skeleton-row-between">
          <div className="skeleton-line skeleton-title-line short" />
          <div className="skeleton-circle skeleton-menu-dots" />
        </div>
        <div className="skeleton-column gap-sm">
          <div className="skeleton-line skeleton-subtitle-line short" />
          <div className="skeleton-line skeleton-subtitle-line" />
          <div className="skeleton-line skeleton-subtitle-line" />
          <div className="skeleton-line skeleton-subtitle-line short" />
        </div>
        <div className="skeleton-line skeleton-progress-bar" />
      </div>
      <div className="point-card-body-skeleton">
        <div className="skeleton-rect skeleton-map-placeholder" />
      </div>
    </div>
  );
}

export function OverviewCardSkeleton() {
  return (
    <div className="skeleton-card overview-card-skeleton">
      <div className="overview-card-top">
        <div className="skeleton-row-between">
          <div className="skeleton-column">
             <div className="skeleton-line skeleton-title-line" style={{width: '180px'}} />
             <div className="skeleton-line skeleton-subtitle-line short" style={{width: '250px', marginTop: '4px'}} />
          </div>
          <div className="skeleton-circle skeleton-menu-dots" />
        </div>
        <div className="skeleton-line skeleton-subtitle-line" style={{marginTop: '12px', width: '200px'}} />
        <div className="skeleton-chips" style={{marginTop: '12px'}}>
            <div className="skeleton-pill skeleton-chip" style={{width: '120px'}} />
            <div className="skeleton-pill skeleton-chip" style={{width: '80px'}} />
        </div>
      </div>
      <div className="overview-card-main">
        <div className="overview-card-left">
           <div className="skeleton-circle skeleton-avatar" style={{width: '48px', height: '48px'}} />
           <div className="skeleton-column" style={{flex: 1, gap: '10px'}}>
               <div className="skeleton-pill" style={{width: '60px', height: '16px'}} />
               <div className="skeleton-line" style={{width: '100%'}} />
               <div className="skeleton-line" style={{width: '90%'}} />
               <div className="skeleton-line" style={{width: '80%'}} />
           </div>
        </div>
        <div className="overview-card-right">
            <div className="skeleton-rect skeleton-map-box" />
        </div>
      </div>
    </div>
  );
}

export function ExecutedPointsSkeleton() {
  return (
    <div className="skeleton-page">
      <div className="skeleton-header">
        <div className="skeleton-title-group">
          <div className="skeleton-circle skeleton-header-icon" />
          <div className="skeleton-column">
            <div className="skeleton-line skeleton-title-line" />
            <div className="skeleton-line skeleton-subtitle-line" />
          </div>
        </div>
      </div>

      <div className="skeleton-card skeleton-filters-card">
        <div className="skeleton-filters-header">
          <div className="skeleton-line skeleton-filters-title" />
        </div>
        <div className="skeleton-filters-grid executed-points-filters-skeleton">
          <div className="skeleton-column">
            <div className="skeleton-line skeleton-label-line" />
            <div className="skeleton-input" />
          </div>
          <div className="skeleton-column">
            <div className="skeleton-line skeleton-label-line" />
            <div className="skeleton-input" />
          </div>
          <div className="skeleton-column">
            <div className="skeleton-line skeleton-label-line" />
            <div className="skeleton-input" />
          </div>
          <div className="skeleton-column">
            <div className="skeleton-line skeleton-label-line" />
            <div className="skeleton-input" />
          </div>
        </div>
      </div>

      <div className="executed-points-grid" style={{ marginTop: '2rem' }}>
        {Array.from({ length: 4 }).map((_, i) => (
          <PointCardSkeleton key={i} />
        ))}
      </div>
    </div>
  );
}

export function CompanyManagerSkeleton() {
  return (
    <div className="skeleton-page">
      <div className="skeleton-header">
        <div className="skeleton-title-group">
          <div className="skeleton-circle skeleton-header-icon" />
          <div className="skeleton-column">
            <div className="skeleton-line skeleton-title-line" />
            <div className="skeleton-line skeleton-subtitle-line" />
          </div>
        </div>
        <div className="skeleton-pill skeleton-button" />
      </div>

      <div className="skeleton-card skeleton-filters-card">
        <div className="skeleton-filters-header">
          <div className="skeleton-line skeleton-filters-title" />
          <div className="skeleton-line skeleton-filters-counter" />
        </div>
        <div className="skeleton-filters-grid">
          <div className="skeleton-column">
            <div className="skeleton-line skeleton-label-line" />
            <div className="skeleton-input" />
          </div>
          <div className="skeleton-column">
            <div className="skeleton-line skeleton-label-line" />
            <div className="skeleton-chips">
              <div className="skeleton-pill skeleton-chip" />
              <div className="skeleton-pill skeleton-chip" />
              <div className="skeleton-pill skeleton-chip" />
            </div>
          </div>
        </div>
      </div>

      <div className="skeleton-card skeleton-table-card">
        <div className="skeleton-table-header">
          <div className="skeleton-line skeleton-header-col" />
          <div className="skeleton-line skeleton-header-col" />
          <div className="skeleton-line skeleton-header-col" />
          <div className="skeleton-line skeleton-header-col" />
          <div className="skeleton-line skeleton-header-col" />
        </div>
        <div className="skeleton-table-rows">
          {Array.from({ length: 5 }).map((_, index) => (
            <div key={index} className="skeleton-table-row">
              <div className="skeleton-table-cell-primary">
                <div className="skeleton-circle skeleton-avatar" />
                <div className="skeleton-column">
                  <div className="skeleton-line skeleton-title-line" />
                  <div className="skeleton-line skeleton-subtitle-line short" />
                </div>
              </div>
              <div className="skeleton-line skeleton-cell-line" />
              <div className="skeleton-line skeleton-cell-line" />
              <div className="skeleton-pill skeleton-tag" />
              <div className="skeleton-row-actions">
                <div className="skeleton-pill skeleton-action" />
                <div className="skeleton-pill skeleton-action" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

